import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion as MuiAccordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { PropTypes } from "prop-types";

import { identifiersData } from "@/data";

const Accordion = ({ details, rowId, summary }) => (
    <MuiAccordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`${identifiersData.ids.accordion}_${rowId}`}>
            <Typography
                color="primary"
                sx={{
                    fontWeight: "bold",
                }}
            >
                {summary}
            </Typography>
        </AccordionSummary>
        <AccordionDetails>{details}</AccordionDetails>
    </MuiAccordion>
);

export default Accordion;

Accordion.propTypes = {
    details: PropTypes.node,
    rowId: PropTypes.number,
    summary: PropTypes.string,
};
